import { render } from "./SubirDocumentoView.vue?vue&type=template&id=f23d89b0&scoped=true"
import script from "./SubirDocumentoView.vue?vue&type=script&lang=js"
export * from "./SubirDocumentoView.vue?vue&type=script&lang=js"

import "./SubirDocumentoView.vue?vue&type=style&index=0&id=f23d89b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f23d89b0"]])

export default __exports__